module.exports = __webpack_public_path__ + "img/hc_pro_two_2.fb1501e5.jpg";